import { render, staticRenderFns } from "./3d-printing.vue?vue&type=template&id=3c0b2738&scoped=true"
import script from "./3d-printing.vue?vue&type=script&lang=js"
export * from "./3d-printing.vue?vue&type=script&lang=js"
import style0 from "./3d-printing.vue?vue&type=style&index=0&id=3c0b2738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0b2738",
  null
  
)

export default component.exports